export type CurrencyCode = 'UZS' | 'USD' | 'EUR' | 'RUB' | 'KZT';

export const currencyLocaleMap: Record<CurrencyCode, string> = {
    UZS: 'uz-UZ', // uzbekistan som
    USD: 'en-US', // u.s. dollar
    EUR: 'de-DE', // euro (defaulting to germany, pick what fits your users)
    RUB: 'ru-RU', // russian ruble
    KZT: 'kk-KZ' // kazakhstani tenge
};
